import { useLeague, attributionEnabled } from '../contexts/LeagueContext'
import { useFanAiLauncherVisible } from './fan-ai/launcherStore'
import { useT } from '@/i18n'
import { siteCoreMessages } from '@/i18n/catalogs/site-core'

// Floating "Powered by ScoreLM" corner badge (#60). Fixed to the bottom-right,
// low-key and semi-transparent so it never competes with page content. Sits
// above normal content (z-40) but below modals/lightboxes (which use z-50+).
// Gated on the tenant's `attribution.corner_badge` flag — ships OFF by default.
export default function ScoreLmBadge() {
  const { league } = useLeague()
  const stacked = useFanAiLauncherVisible()
  const poweredBy = useT(siteCoreMessages).widgets.badge.poweredBy

  if (!attributionEnabled(league, 'corner_badge')) return null

  // Bottom offset: website templates with a bottom bar raise it through
  // --site-fab-offset (default 0). When the Fan AI launcher is on screen the
  // badge stacks above it, right edges aligned (#489): the bubble is 48px tall
  // at bottom 1rem (1.5rem from sm), so the badge sits 8px above its top.
  const position = stacked
    ? 'bottom-[calc(4.5rem_+_var(--site-fab-offset,0px))] right-4 sm:bottom-[calc(5rem_+_var(--site-fab-offset,0px))] sm:right-6'
    : 'bottom-[calc(0.75rem_+_var(--site-fab-offset,0px))] right-3'
  return (
    <a
      href="https://scorelm.com"
      target="_blank"
      rel="noopener noreferrer"
      aria-label={poweredBy}
      className={`keep-white fixed ${position} z-40 rounded-full border border-white/10 bg-black/40 px-3 py-1.5 text-[11px] font-medium text-white/60 backdrop-blur-sm transition-colors hover:text-white/90`}
    >
      {poweredBy}
    </a>
  )
}
